import script from "./ChartUI.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartUI.vue?vue&type=script&setup=true&lang=js"

import "./ChartUI.vue?vue&type=style&index=0&id=2527b32a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2527b32a"]])

export default __exports__